"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Price = _interopRequireDefault(require("../Price"));
var _Label = _interopRequireDefault(require("../Label"));
var _Button = _interopRequireDefault(require("../Button"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _constant = require("../JourneySegment/constant");
var _JourneyPriceCTA = _interopRequireDefault(require("./JourneyPriceCTA.proptypes"));
var _constant2 = require("./constant");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledJourneyPriceCTAContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledJourneyPriceCTAContainer",
  componentId: "sc-84l2fp-0"
})(["", ""], function (_ref) {
  var horizontal = _ref.horizontal,
    theme = _ref.theme,
    ctaPosition = _ref.ctaPosition;
  return !horizontal ? 'display:block;' : "\n        display: flex;\n        align-items: ".concat(ctaPosition, ";\n        justify-content: space-between;\n        height: ").concat(theme.space.large, ";\n    ");
});
var StyledPriceContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledPriceContainer",
  componentId: "sc-84l2fp-1"
})(["", ""], function (_ref2) {
  var horizontal = _ref2.horizontal,
    inlineDetails = _ref2.inlineDetails;
  return inlineDetails ? "display:flex; align-self:flex-end;cursor:pointer; align-items: baseline;" : !horizontal && 'display: block;';
});
var StyledPriceAmount = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledPriceAmount",
  componentId: "sc-84l2fp-2"
})(["", ""], function (_ref3) {
  var horizontal = _ref3.horizontal;
  return !horizontal ? "\n    display: flex;\n    justify-content: flex-end;\n  " : "\n  display: flex;\n  justify-content: flex-start;\n  ";
});
var StyledPercentageDiscountLabel = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledPercentageDiscountLabel",
  componentId: "sc-84l2fp-3"
})(["padding-left:", ";font-family:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.micro);
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.fontFamily.default, ", Roboto");
});
var StyledPromoTagContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledPromoTagContainer",
  componentId: "sc-84l2fp-4"
})(["text-align:right;font-family:", ";& > div:not(:last-child){margin-right:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.fontFamily.default, ", Roboto");
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.space.micro);
});
var StyledDiscountWrapper = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledDiscountWrapper",
  componentId: "sc-84l2fp-5"
})(["", ""], function (_ref8) {
  var horizontal = _ref8.horizontal;
  return !horizontal ? "\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  " : "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  ";
});
var StyledGuestText = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledGuestText",
  componentId: "sc-84l2fp-6"
})(["", " display:flex;align-items:center;p{margin-right:", ";}"], function (_ref9) {
  var horizontal = _ref9.horizontal,
    isOneway = _ref9.isOneway;
  return (!horizontal || isOneway) && "\n    justify-content: flex-end;\n  ";
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.mini;
});
var StyledCTAContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledCTAContainer",
  componentId: "sc-84l2fp-7"
})(["margin-left:", ";", " ", ""], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.XSmall;
}, function (_ref12) {
  var horizontal = _ref12.horizontal;
  return !horizontal && "\n    display: block;\n  ";
}, function (_ref13) {
  var inlineDetails = _ref13.inlineDetails;
  return inlineDetails && "\n  display:flex;\n  align-self:flex-end;\n\n";
});
var StyledCTAButton = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledCTAButton",
  componentId: "sc-84l2fp-8"
})(["position:relative;", ";", ""], function (_ref14) {
  var horizontal = _ref14.horizontal,
    theme = _ref14.theme;
  return !horizontal && "\n    display: flex;\n    justify-content: flex-end;\n    margin-top: ".concat(theme.space.small, ";\n    margin-bottom: ").concat(theme.space.small, ";\n  ");
}, function (_ref15) {
  var inlineDetails = _ref15.inlineDetails,
    theme = _ref15.theme;
  return inlineDetails && "\n    align-items: center;\n    margin-top: ".concat(theme.space.none, ";\n    margin-bottom: ").concat(theme.space.none, ";\n  ");
});
var StyledCTAText = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledCTAText",
  componentId: "sc-84l2fp-9"
})(["", " display:flex;align-items:center;cursor:pointer;p{margin-right:", ";}", ""], function (_ref16) {
  var horizontal = _ref16.horizontal,
    isOneway = _ref16.isOneway;
  return (!horizontal || isOneway) && "\n    justify-content: flex-end;\n  ";
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.tiny;
}, function (_ref18) {
  var viewIconFirst = _ref18.viewIconFirst,
    theme = _ref18.theme;
  return viewIconFirst && "margin-top:".concat(theme.space.small);
});
var StyledCTASpinner = _styledComponents.default.div.withConfig({
  displayName: "JourneyPriceCTA__StyledCTASpinner",
  componentId: "sc-84l2fp-10"
})(["position:absolute;left:calc(50% - 12.5px);top:calc(50% - 12.5px);"]);
var StyledCTALoaderText = _styledComponents.default.span.withConfig({
  displayName: "JourneyPriceCTA__StyledCTALoaderText",
  componentId: "sc-84l2fp-11"
})(["color:", ";"], function (_ref19) {
  var isSelected = _ref19.isSelected,
    theme = _ref19.theme;
  return isSelected ? theme.colors.default : theme.colors.primary;
});
var JourneyPriceCTA = function JourneyPriceCTA(_ref20) {
  var accessible = _ref20.accessible,
    theme = _ref20.theme,
    customProperties = _ref20.customProperties,
    price = _ref20.price,
    strikethroughPrice = _ref20.strikethroughPrice,
    percentageDiscount = _ref20.percentageDiscount,
    guest = _ref20.guest,
    _handleClick = _ref20.handleClick,
    handleViewClick = _ref20.handleViewClick,
    viewIconText = _ref20.viewIconText,
    viewIconColor = _ref20.viewIconColor,
    viewIcon = _ref20.viewIcon,
    horizontal = _ref20.horizontal,
    customPercentageDiscountText = _ref20.customPercentageDiscountText,
    customGuestText = _ref20.customGuestText,
    customDetailText = _ref20.customDetailText,
    customIconSize = _ref20.customIconSize,
    translation = _ref20.translation,
    tripType = _ref20.tripType,
    locale = _ref20.locale,
    loading = _ref20.loading,
    disabled = _ref20.disabled,
    defaultDisabledFeatures = _ref20.defaultDisabledFeatures,
    isSelected = _ref20.isSelected,
    showButton = _ref20.showButton,
    ctaPosition = _ref20.ctaPosition,
    inlineDetails = _ref20.inlineDetails,
    viewIconFirst = _ref20.viewIconFirst,
    isMobile = _ref20.isMobile,
    promoTags = _ref20.promoTags,
    showCurrency = _ref20.showCurrency,
    defaultIDRLocale = _ref20.defaultIDRLocale,
    isSoldOut = _ref20.isSoldOut;
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);
  var isOneway = tripType === _constant.TRIP_TYPES.oneway;
  var handleKeyUp = function handleKeyUp(event) {
    if (event.key === 'Enter') {
      handleViewClick(event);
    }
  };
  var renderViewIcon = function renderViewIcon(overrideIcon) {
    return /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: isSoldOut ? _constant2.COLOR.greyDark : viewIconColor,
      fontSize: customIconSize || 'small',
      icon: overrideIcon || viewIcon,
      theme: theme
    });
  };
  var isMoveTheme = theme === _constant2.THEMES.MOVE;
  var renderDetailsText = function renderDetailsText() {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line
      _react.default.createElement(_Text.default, {
        accessible: accessible,
        display: "inlineFlex",
        theme: theme,
        type: "small",
        color: isSoldOut ? _constant2.COLOR.greyDark : viewIconColor
      }, customDetailText || language.details)
    );
  };
  function getColor(selected, feature) {
    if (selected) {
      return _constant2.moveSecondaryButton[isMoveTheme][feature];
    }
    return _constant2.movePrimaryButton[isMoveTheme][feature];
  }
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledJourneyPriceCTAContainer, (0, _extends2.default)({
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties, {
    horizontal: horizontal,
    ctaPosition: ctaPosition
  }), !isSoldOut && /*#__PURE__*/_react.default.createElement(StyledPriceContainer, {
    horizontal: horizontal,
    inlineDetails: inlineDetails
  }, /*#__PURE__*/_react.default.createElement(StyledPriceAmount, {
    horizontal: horizontal
  }, /*#__PURE__*/_react.default.createElement(_Price.default, {
    allowLocaleFormat: true,
    locale: locale,
    accessible: accessible,
    amount: price && price.amount,
    color: "neutral",
    currency: price && price.currency.toUpperCase(),
    theme: theme,
    customFontSize: "textSmall",
    customCurrencySize: "titleSmall",
    priceTemplate: "DEFAULT",
    decimalType: "CEIL",
    noDecimalValues: true,
    defaultIDRLocale: defaultIDRLocale
  })), strikethroughPrice && percentageDiscount && /*#__PURE__*/_react.default.createElement(StyledDiscountWrapper, null, /*#__PURE__*/_react.default.createElement(_Price.default, {
    locale: locale,
    accessible: accessible,
    amount: strikethroughPrice && strikethroughPrice,
    color: "greyDark",
    hideCurrency: !showCurrency,
    currency: price && price.currency.toUpperCase(),
    strikethrough: true,
    theme: theme,
    customFontSize: "textSmall",
    customCurrencySize: "titleSmall",
    priceTemplate: "TEMPLATE3",
    decimalType: "CEIL",
    noDecimalValues: true,
    defaultIDRLocale: defaultIDRLocale
  }), /*#__PURE__*/_react.default.createElement(StyledPercentageDiscountLabel, null, percentageDiscount > 0 && /*#__PURE__*/_react.default.createElement(_Label.default, {
    accessible: true,
    labelColor: "greenLight",
    textColor: "tertiaryDark",
    theme: theme
  }, customPercentageDiscountText || language.percentageDiscount.replace("{percent}", percentageDiscount)))), promoTags && promoTags.length > 0 && /*#__PURE__*/_react.default.createElement(StyledDiscountWrapper, {
    horizontal: horizontal
  }, /*#__PURE__*/_react.default.createElement(StyledPromoTagContainer, null, promoTags.map(function (promoTag) {
    return /*#__PURE__*/_react.default.createElement(_Label.default, {
      key: promoTag,
      accessible: true,
      labelColor: "greenLight",
      textColor: "tertiaryDark",
      theme: theme
    }, promoTag);
  }))), guest > 0 && /*#__PURE__*/_react.default.createElement(StyledGuestText, (0, _extends2.default)({
    horizontal: horizontal
  }, horizontal && !inlineDetails && {
    onClick: function onClick(e) {
      return handleViewClick(e);
    }
  }, {
    isOneway: isOneway,
    onKeyUp: function onKeyUp(e) {
      return handleKeyUp(e);
    }
  }), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: "inlineFlex",
    theme: theme,
    type: "small",
    color: "greyDark"
  }, customGuestText || language.guest.replace("{count}", guest)), ' ', !!handleViewClick && !customGuestText && horizontal && !isOneway && !inlineDetails && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, viewIconText && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: "inlineFlex",
    theme: theme,
    type: "small",
    color: viewIconColor,
    bold: true
  }, viewIconText), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: viewIconColor,
    fontSize: "small",
    icon: viewIcon,
    theme: theme
  })))), /*#__PURE__*/_react.default.createElement(StyledCTAContainer, {
    horizontal: horizontal,
    inlineDetails: inlineDetails
  }, showButton && /*#__PURE__*/_react.default.createElement(StyledCTAButton, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    accessible: accessible,
    backgroundColor: getColor(isSelected, 'backgroundColor'),
    border: getColor(isSelected, 'border'),
    color: getColor(isSelected, 'color'),
    customProperties: {
      paddingLeft: '1rem',
      paddingRight: '1rem'
    },
    boxShadow: false,
    width: customProperties && customProperties.customSelectButtonWidthMobile,
    buttonType: "button",
    cardIndex: 0,
    handleClick: function handleClick(e) {
      return _handleClick(e);
    },
    size: "normal",
    target: "tab",
    theme: theme,
    type: "normal",
    disabled: disabled,
    defaultDisabledFeatures: defaultDisabledFeatures
  }, loading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledCTALoaderText, {
    isSelected: isSelected
  }, language.ctaText), /*#__PURE__*/_react.default.createElement(StyledCTASpinner, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    animationDuration: "1s",
    color: getColor(isSelected, 'color'),
    height: "25px",
    show: true,
    strokeWidth: "3",
    theme: theme,
    width: "25px"
  }))) : language.ctaText)), !showButton && isMobile && /*#__PURE__*/_react.default.createElement(StyledCTAButton, {
    inlineDetails: inlineDetails
  }, viewIconFirst && renderViewIcon(), " ", renderDetailsText()), /*#__PURE__*/_react.default.createElement(StyledCTAButton, null, isSoldOut && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: "inlineFlex",
    theme: theme,
    type: "small",
    color: _constant2.COLOR.greyDark
  }, language.soldOut)), (!horizontal || isOneway) && /*#__PURE__*/_react.default.createElement(StyledCTAText, {
    onClick: function onClick(e) {
      return handleViewClick(e);
    },
    onKeyUp: function onKeyUp(e) {
      return handleKeyUp(e);
    },
    horizontal: horizontal,
    isOneway: isOneway,
    viewIconFirst: viewIconFirst
  }, viewIconFirst && renderViewIcon(), renderDetailsText(), ' ', !!handleViewClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, viewIconText && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: "inlineFlex",
    theme: theme,
    type: "small",
    color: viewIconColor,
    bold: true
  }, viewIconText), !viewIconFirst && renderViewIcon())))));
};
JourneyPriceCTA.propTypes = _JourneyPriceCTA.default.PropTypes;
JourneyPriceCTA.defaultProps = _JourneyPriceCTA.default.DefaultProps;
var _default = JourneyPriceCTA;
exports.default = _default;